import { useEffect, useState } from 'react'
import { SingleCheckbox } from '../../../../../ui/molecules/SingleCheckbox'
import '../../../styles.scss'
import { VariationTable } from '../components/variationsTable'
import Button from '../../../../../ui/molecules/button'
import { useAppDispatch, useAppSelector } from '../../../../../lib/redux/hooks'
import { setOnEdit } from '../slice'
import Input from '../../../../../ui/molecules/input'
import { NotificationExpirationTypeOptions, optionsFormatter } from '../../../../../utils'

export function NotifyStatusForms() {
    const dispatch = useAppDispatch()
    const notificationStatusState = useAppSelector(state => state.notificationStatus)
    const notificationStatusResponse = notificationStatusState.getNotificationStatusByIdResponse
    const [nextNotify, setNextNotify] = useState<boolean>(false)
    const [nonCompliantNotify, setNonCompliantNotify] = useState<boolean>(false)
    const [otherMotivationsNotify, setOtherMotivationsNotify] = useState<boolean>(false)
    const [m005Emission, setM005Emission] = useState<boolean>(false)
    const [m005Validation, setM005Validation] = useState<boolean>(false)
    const [inspectionVisit, setInspectionVisit] = useState<boolean>(false)

    useEffect(() => {
        if (notificationStatusResponse === undefined)
            return

        if (notificationStatusResponse.certifiedSubsequentNotificationIssued !== null)
            setNextNotify(notificationStatusResponse?.certifiedSubsequentNotificationIssued)

        if (notificationStatusResponse.certifiedNonCompliantNotification !== null)
            setNonCompliantNotify(notificationStatusResponse?.certifiedNonCompliantNotification)

        if (notificationStatusResponse.certifiedOtherCauses !== null)
            setOtherMotivationsNotify(notificationStatusResponse?.certifiedOtherCauses)

        if (notificationStatusResponse.m005IssueRequest !== null)
            setM005Emission(notificationStatusResponse?.m005IssueRequest)

        if (notificationStatusResponse.m005IsValid !== null)
            setM005Validation(notificationStatusResponse?.m005IsValid)

        if (notificationStatusResponse.inspectionVisitNeeded !== null)
            setInspectionVisit(notificationStatusResponse?.inspectionVisitNeeded)
    }, [notificationStatusResponse])

    return (
        <div className="notify-container">
            <div className='notify-header'>
                <div className='text-left'>
                    <span className='notify-title-bold' style={{ color: '#fff' }}>Notifica </span>
                    <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                    <span className='notify-title-bold' style={{ color: '#d9e6e8' }}> Stato</span>
                </div>
            </div>

            <div style={{ padding: '24px' }}>
                <div className='pb-5' style={{ borderBottom: '1px solid #74A4A9' }}>
                    <div className='text-left mb-5'>
                        <div className='notify-subtitle'>
                            Monitoraggio Iter Notifica - Tempistica Visita Ispettiva
                        </div>
                        <span className='notify-text-content'>
                            {
                                notificationStatusResponse?.expirationType &&
                                optionsFormatter(notificationStatusResponse?.expirationType, NotificationExpirationTypeOptions)
                            }
                        </span>
                    </div>

                    <div className='text-left'>
                        <div className='notify-subtitle'>
                            Monitoraggio Iter Notifica - Tempistiche emissione CDX M005 - Documento Giustificativo
                        </div>
                        <span className='notify-text-bold pr-2'>
                            {
                                notificationStatusResponse?.expirationType &&
                                optionsFormatter(notificationStatusResponse?.expirationType, NotificationExpirationTypeOptions)
                            }
                        </span>
                        <span className='notify-text-content'>

                        </span>
                    </div>
                </div>

                <div className='pt-5 pb-5' style={{ borderBottom: '1px solid #74A4A9' }}>
                    <div className='text-left'>
                        <div className='notify-subtitle mb-3'>
                            Certificato associato alla notifica
                        </div>
                        <div className='mb-3'>
                            <SingleCheckbox
                                disabled
                                label='Non emettere certificato - emessa Notifica successiva'
                                checked={nextNotify}
                                setChecked={(value) => setNextNotify(value)}
                            />
                        </div>
                        <div className='mb-3'>
                            <SingleCheckbox
                                disabled
                                label='Non emettere certificato - Notifica non conforme'
                                checked={nonCompliantNotify}
                                setChecked={(value) => setNonCompliantNotify(value)}
                            />
                        </div>
                        <div className='mb-5'>
                            <SingleCheckbox
                                disabled
                                label='Non emettere certificato - Altre cause'
                                checked={otherMotivationsNotify}
                                setChecked={(value) => setOtherMotivationsNotify(value)}
                            />
                            <div className='ml-[25px]'>
                                <Input
                                    disabled={!otherMotivationsNotify}
                                    placeholder='Specifica altre cause...'
                                    value={notificationStatusResponse?.certifiedNote}
                                />
                            </div>
                        </div>
                        {
                            notificationStatusResponse?.isImported && (
                                <div>
                                    <div className='mb-3'>
                                        <SingleCheckbox
                                            disabled
                                            label='Richiesta emissione M005'
                                            checked={m005Emission}
                                            setChecked={(value) => setM005Emission(value)}
                                        />
                                    </div>
                                    <div>
                                        <SingleCheckbox
                                            disabled
                                            label='M005 in corso di validità'
                                            checked={m005Validation}
                                            setChecked={(value) => setM005Validation(value)}
                                        />
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>

                <div className='pt-5 pb-5' style={{ borderBottom: '1px solid #74A4A9' }}>
                    <div className='text-left'>
                        <div className='notify-subtitle mb-3'>
                            Visita Ispettiva
                        </div>

                        <div style={{ display: 'flex', gap: '144px' }}>
                            {
                                notificationStatusResponse?.isImported &&
                                <SingleCheckbox
                                    disabled
                                    label='Effettuare visita Ispettiva'
                                    checked={inspectionVisit}
                                    setChecked={(value) => setInspectionVisit(value)}
                                />
                            }

                            <div>
                                <span className='notify-text-bold pr-2'>
                                    Visita Ispettiva
                                </span>
                                <span className='notify-text-content'>
                                    Visita del 15/04/2025 (TO FUTURE)
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='pt-5 pb-5' style={{ borderBottom: '1px solid #74A4A9' }}>
                    <div className='text-left'>
                        <div className='notify-subtitle mb-3'>
                            Richiesta Integrazione Documenti (R.I.D.)
                        </div>

                        <span className='notify-text-content'>
                            {notificationStatusResponse?.documentIntegrationRequestInfo || "Nessuna RID per l'operatore."}
                        </span>
                    </div>
                </div>

                <div className='pt-5 pb-5'>
                    <div className='text-left'>
                        <div className='notify-subtitle mb-3'>
                            Cause della variazione
                        </div>
                    </div>

                    <VariationTable disabled defaultValue={notificationStatusResponse?.variationCauses} />
                </div>

                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant='solid'
                        color='dimgrey'
                        iconPosition='off'
                        size='md'
                        label='Modifica'
                        onClick={() => dispatch(setOnEdit(true))}
                    />
                </div>
            </div>
        </div>
    )
}